import writeXlsxFile from "write-excel-file";
import moment from "moment";
import { toast } from "react-toastify";
// service
import { getOnline } from "../../../../../utils/services/dashboardSuperScreen";
// utils
import { parseFirestoreDate } from "../../../../../utils/helpers/files/formatDate";

// quantidade de registros buscados por requisição na exportação
const EXPORT_LIMIT = 999;

// formata a data em que o participante ficou online para "DD/MM/AAAA - HH:mm"
export function formatDate(date) {
  const parsedDate = parseFirestoreDate(date);
  if (!parsedDate) return "";

  return moment(parsedDate).format("DD/MM/YYYY - HH:mm");
}

// atualiza a barra de progresso do WaitExport
function updateProgress(current, total) {
  const progressBar = document.querySelector(".export-progress");
  const percentageBar = document.querySelector(".export-percentage");
  const percentage = (current / total) * 100;

  if (progressBar) progressBar.style.width = `${percentage}%`;
  if (percentageBar) percentageBar.innerHTML = `${percentage.toFixed(0)}%`;
}

// busca todas as páginas de participantes online e gera o arquivo xlsx
export async function createXlsx({
  eventId,
  transmissionID,
  search,
  countData,
  mobileapps,
  setFinishExport,
  setExportInProgress,
}) {
  const schema = [
    {
      column: "ID do Participante",
      type: String,
      value: (online) => online.id,
    },
    {
      column: "Nome do Participante",
      type: String,
      value: (online) => online.name,
    },
    {
      column: "Data e Hora",
      type: String,
      value: (online) => formatDate(online.date),
    },
  ];

  try {
    const allData = [];
    const numberOfRequisitions = Math.ceil(countData / EXPORT_LIMIT);

    for (let page = 1; page <= numberOfRequisitions; page += 1) {
      const res = await getOnline({
        eventId,
        transmissionID,
        pageSize: EXPORT_LIMIT,
        offset: page - 1,
        search,
        mobileapps,
      });

      if (!res?.success) {
        throw new Error("Erro ao buscar participantes online.");
      }

      allData.push(...res.data);
      updateProgress(page, numberOfRequisitions);
    }

    if (allData.length > 0) {
      await writeXlsxFile(allData, {
        schema,
        fileName: "ParticipantesOnline.xlsx",
      });
    }

    setTimeout(() => {
      setFinishExport(true);
    }, 1000);
  } catch (error) {
    setExportInProgress(false);
    toast.error("Erro ao exportar participantes online.");
  }
}
